(() => {
  const root = document.getElementById('lasx-home');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const hero = root.querySelector('#lasx-film-hero-video');
  const heroToggle = root.querySelector('#lasx-film-hero-toggle');
  const fullFilm = root.querySelector('#lasx-film-full-film');
  const dialog = root.querySelector('#lasx-film-film-dialog');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let heroLoaded = false;
  let userPaused = false;
  let returnFocus;
  let resumeAfterDialog = false;
  let previousOverflow = '';

  function loadHero() {
    if (heroLoaded) return;
    const mobile = window.matchMedia('(max-width: 767px)').matches;
    hero.src = mobile ? hero.dataset.mobile : hero.dataset.desktop;
    hero.muted = true;
    heroLoaded = true;
  }
  function reflectPlayback() {
    heroToggle.textContent = hero.paused ? 'Play video' : 'Pause video';
    heroToggle.setAttribute('aria-label', hero.paused ? 'Play background video' : 'Pause background video');
  }
  async function playHero() {
    loadHero();
    try { await hero.play(); } catch { reflectPlayback(); }
  }
  hero.addEventListener('play', reflectPlayback);
  hero.addEventListener('pause', reflectPlayback);
  hero.addEventListener('error', () => { heroToggle.textContent = 'Watch full film'; });
  heroToggle.addEventListener('click', () => {
    if (hero.error) { openFilm(heroToggle); return; }
    userPaused = !hero.paused;
    hero.paused ? playHero() : hero.pause();
  });
  if (!reducedMotion.matches && !navigator.connection?.saveData) playHero();
  reducedMotion.addEventListener('change', () => { if (reducedMotion.matches) hero.pause(); });
  const visibilityObserver = new IntersectionObserver(([entry]) => {
    if (!entry.isIntersecting) hero.pause();
    else if (heroLoaded && !userPaused && !reducedMotion.matches && !dialog.open && !document.hidden) playHero();
  }, {threshold: .05});
  visibilityObserver.observe(hero);
  document.addEventListener('visibilitychange', () => { if (document.hidden) hero.pause(); });

  function openFilm(trigger) {
    returnFocus = trigger;
    resumeAfterDialog = !hero.paused;
    hero.pause();
    if (!fullFilm.src) {
      fullFilm.src = fullFilm.dataset.film;
      fullFilm.load();
    }
    dialog.showModal();
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    root.querySelector('#lasx-film-close-film').focus();
    fullFilm.play().catch(() => {});
  }
  root.querySelectorAll('[data-open-film]').forEach(button => button.addEventListener('click', () => openFilm(button)));
  root.querySelector('#lasx-film-close-film').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    fullFilm.pause();
    document.body.style.overflow = previousOverflow;
    returnFocus?.focus();
    if (resumeAfterDialog && !userPaused && !reducedMotion.matches) playHero();
  });
  fullFilm.addEventListener('error', () => { root.querySelector('#lasx-film-film-error').hidden = false; });

})();
